export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:url","property":"og:url","content":"https://helixapp.com"},{"hid":"keywords","name":"keywords","content":"injective protocol, dapp, decentralized app, cryptocurrency, cryptocurrency exchange, exchange, ethereum, erc20, futures, perpetuals, futures protocol, cosmos, spot trading, derivatives, injective, ibc, cross-chain"},{"hid":"description","name":"description","content":"Trade on Helix - the premier decentralized spot and derivatives exchange with low fees and gas free execution"},{"hid":"author","name":"author","content":"InjectiveLabs"},{"hid":"og:type","property":"og:type","content":"exchange"},{"hid":"og:image","property":"og:image","content":"https://helixapp.com/images/og-helix.jpeg"},{"hid":"og:description","property":"og:description","content":"Trade on Helix - the premier decentralized spot and derivatives exchange with low fees and gas free execution"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@InjectiveLabs"},{"name":"twitter:image","content":"https://helixapp.com/images/og-helix.jpeg"},{"hid":"twitter:creator","property":"twitter:creator","content":"@InjectiveLabs"},{"hid":"twitter:description","property":"twitter:description","content":"Trade on Helix - the premier decentralized spot and derivatives exchange with low fees and gas free execution"},{"hid":"twitter:title","property":"twitter:title","content":"Helix | The Premier Decentralized Spot and Derivatives Exchange"},{"hid":"og:title","property":"og:title","content":"Helix | The Premier Decentralized Spot and Derivatives Exchange"},{"hid":"og:site_name","property":"og:site_name","content":"Helix | The Premier Decentralized Spot and Derivatives Exchange"},{"hid":"title","property":"title","content":"Helix | The Premier Decentralized Spot and Derivatives Exchange"},{"hid":"apple-itunes-app","name":"apple-itunes-app","content":"app-id=6737353178"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"},{"rel":"shortcut icon","type":"image/png","href":"/favicon.png"},{"rel":"apple-touch-icon","type":"image/png","href":"/favicon.png"},{"as":"font","rel":"preload","type":"font/woff2","href":"/Inter-Regular.woff2","crossorigin":"anonymous"}],"style":[],"script":[{"src":"/chart/charting_library/charting_library.js","body":"true"},{"innerHTML":"var exports = {}"}],"noscript":[],"title":"Helix | The Premier Decentralized Spot and Derivatives Exchange","htmlAttrs":{"lang":"en"},"bodyAttrs":{"class":"font-sans"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true